<template>
  <router-link class="v2-course-list-item" tag="div" :to="'/courses/' + data.id">
    <div class="wrapper">
      <div class="img" :style="bgd(data.img)" />
      <div class="right">
        <h1>{{ data.title }}</h1>
        <h2>{{ data.subtitle }}</h2>
        <div
          class="promo__button"
          v-if="$store.state.isPromo && data.is_promo"
          :class="{ lifted: data.limitation }"
        >
          <span>
            <i class="anyteachicon anyteach-1212 promo-icon" />
            {{ $store.state.promoData.btn2 }}
          </span>
        </div>
        <div class="price" v-else>
          <span v-if="maxPrice === minPrice && maxPrice != 0">¥{{ minPrice }}</span>
          <span v-else-if="maxPrice != minPrice && maxPrice != 0">¥{{ minPrice }} 起</span>
          <span v-else>免费</span>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "V2CourseListItem",
  props: ["data"],
  data() {
    return {
      is_promo: true,
      minPrice: this.data.events.reduce((accumulator, value) => {
        if (value.price < accumulator && value.is_demo == 0) {
          accumulator = value.price
        }
        return accumulator
      }, this.data.events[0].price),
      maxPrice: this.data.events.reduce((accumulator, value) => {
        if (value.price > accumulator) {
          accumulator = value.price
        }
        return accumulator
      }, this.data.events[0].price),
    }
  },
  methods: {
    bgd(url) {
      return `background-image: url(${url})`
    },
  },
}
</script>
<style scoped lang="scss">
.v2-course-list-item {
  padding: 15px 5%;

  &:first-of-type {
    margin-top: -10px;
  }

  .wrapper {
    max-width: 500px;
    margin: auto;
    display: flex;
    align-items: center;

    .img {
      min-width: 50%;
      height: 110px;

      border-radius: 5px;
      background-color: #eee;
      background-position: center;
      background-size: cover;
      box-shadow: $deep-shadow;
    }

    @media only screen and (max-width: 320px) {
      .img {
        min-width: 45%;
        height: 90px;
      }
    }

    .right {
      padding: 0 0 0 15px;
      h1 {
        @include avenir-demi();
        font-size: 1rem;
        line-height: 1.2;
        margin: 3px 0 5px 0;
      }

      h2 {
        @include avenir();
        font-size: 0.85rem;
        font-weight: 400;
        opacity: 0.6;
        color: $black;
        margin: 0;
        line-height: 1.4;
      }
      .price {
        @include avenir-demi();
        // text-align: center;
        // background: $lightBlue;
        // color: $blue;
        // height: 25px;
        // border-radius: 25px;
        // min-width: 40px;
        // padding: 6px 10px;
        padding: 0;
        color: $red;
        font-size: 0.8rem;
        transition: all 0.1s;
        border: none;
        margin: 10px 0 0 0;
        line-height: 12.5px;

        &:disabled {
          opacity: 0.8;
          color: $grey;
          background: #eee;
        }
        i {
          font-size: 12px;
        }
      }
      .promo__button {
        background: $d11__bgd;
        color: $d11__main;
      }
    }
  }
  &:active {
    background: #f9f9f9;
  }

  .cashier {
    width: 100%;
    padding: 10px 0 0 0;
    border-radius: 5px;
    transition: all 0.2s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      h1 {
        font-size: 15px;
        font-weight: bold;
        line-height: 1.4;
        margin: 3px 0 3px 0;
      }

      h2 {
        font-size: 13px;
        font-weight: 300;
        color: $black;
        margin: 0;
      }
    }

    .right {
      position: relative;
      margin-left: 10px;

      button {
        text-align: center;
        background: $lightBlue;
        color: $blue;
        height: 30px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 500;
        transition: all 0.1s;
        border: none;
        min-width: 50px;
        @include avenir-demi();

        &:hover {
          opacity: 0.7;
        }

        &:disabled {
          opacity: 0.8;
          color: $grey;
          background: #eee;
        }
      }

      #tag {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: $black;
        text-align: center;
        width: 100%;
        top: 27px;
        position: absolute;
        transform: scale(0.8);
      }
    }

    .lifted {
      margin-bottom: 13px;
    }
  }
}

#v2-course-list-item:first-of-type {
  padding-top: 0;
}
</style>
